import { Paper } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createLink } from '../../GlobalApp/components';
import { themeColors } from '../../JuvareTheme';
import { LandingPage } from '../../LandingPage';
import { MarkdownStyle } from '../../MarkdownStyle';
import { NavigationContext } from '../../NavigationContext';
export const Page = (props) => {
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const headerItems = props.pages.map((page) => {
        var _a;
        return ({
            label: page.label,
            href: 'path' in page ? createLink([(_a = props.basename) !== null && _a !== void 0 ? _a : '/', page.path]) : undefined,
            onClick: () => {
                if ('path' in page) {
                    navigationContext.navigate(() => navigate('/' + page.path));
                }
                else {
                    const onClick = page.onClick;
                    navigationContext.navigate(() => onClick(navigate));
                }
            },
            'data-test': page['data-test'],
        });
    });
    let contentElement;
    if (props.contentHtml) {
        contentElement = React.createElement("div", { dangerouslySetInnerHTML: { __html: props.contentHtml } });
    }
    else {
        contentElement = props.contentElement;
    }
    return (React.createElement(LandingPage, { image: props.image, juvareHref: props.juvareHref, juvareOnClick: props.juvareOnClick, appImage: props.appImage, appTitle: props.appTitle, environment: props.environment, environmentLabel: props.environmentLabel, headerItems: headerItems, contentTitle: props.contentTitle, contentElement: (dialog) => props.border ? (React.createElement(Paper, { variant: 'outlined', sx: { p: 2 } },
            React.createElement(MarkdownStyle, { firstHeading: 'h5', textColor: dialog ? undefined : themeColors.text.subtle }, contentElement))) : (React.createElement(MarkdownStyle, { firstHeading: dialog ? 'h6' : 'h5', textColor: dialog ? undefined : themeColors.text.subtle }, contentElement)), loginElement: props.loginElement, backToLoginOnClick: props.loginElement ? undefined : () => navigationContext.navigate(() => navigate('/')), backToLoginLabel: props.backToLoginLabel, footerCopyright: props.footerCopyright }));
};
